import { addMinutes, isValid } from "date-fns"
import React, { useEffect, useState } from "react"
import { keycloak } from "../../../lib/keycloak/index.ts"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts"
import { colors } from "../../../ui/colors.ts"
import { CloseIcon } from "../../../ui/icons/closeIcon.tsx"
import { ButtonComponent } from "../../../ui/molecules/button/index.tsx"
import { Calendar } from "../../../ui/molecules/calendar/index.tsx"
import { InputComponent } from "../../../ui/molecules/input/index.tsx"
import { SelectComponent } from "../../../ui/molecules/select/index.tsx"
import { SpinnerComponent } from "../../../ui/molecules/spinner/index.tsx"
import { ModalComponent } from "../../../ui/organisms/modal/index.tsx"
import { findByIdFinancialAdvisor, setOpenConfirmModal } from "../slice.ts"
import { AppointmentsCreateDTO, AppointmentsStatus, AppointmentsTypology } from "./dto.ts"
import { appointmentsCreate, appointmentsDelete, findAllAppointments, rescheduleAppointment, resetNewAppointmentRequest, setAppointmentCreateRequestCompanyId, setAppointmentCreateRequestNotes, setAppointmentCreateRequestTitle, setAppointmentCreateRequestTypology, setFindByIdAppointmentResponse, setFindByIdAppointmentStatus, setNewAppointmentModal, setOpenAppointmentConfirmOrDenyModal, updateStatusAppointment } from "./slice.ts"
import { fullDaysMap } from "../../../lib/utilis/index.ts"
import { ConfirmModal } from "../../../ui/organisms/confirmModal/index.tsx"

export function NewAppointmentModal() {

    const appointmentsState = useAppSelector(state => state.appointments)
    const companyState = useAppSelector(state => state.company)
    const authState = useAppSelector(state => state.auth)
    const financialAdvisorState = useAppSelector(state => state.financialAdvisor)

    const dispatch = useAppDispatch()

    const [date, setDate] = useState<Date | null>(null)
    const [time, setTime] = useState<Date | null>(null)
    const [errorTime, setErrorTime] = useState<boolean>(false)
    const [availableSlots, setAvailableSlots] = useState<Date[]>([]);
    const [year, setYear] = useState(new Date().getFullYear())
    const [month, setMonth] = useState(new Date().getMonth())
    const [isDeleteAppointment, setIsDeleteAppointment] = useState<string | undefined>()

    let companyName: string = ''

    if (companyState.findAllCompanyResponse && companyState.findAllCompanyResponse?.data.find(item => item.id === appointmentsState.findByIdAppointmentResponse?.id)) {
        const company = companyState.findAllCompanyResponse?.data.find(item => item.id === appointmentsState.findByIdAppointmentResponse?.id)!
        companyName = company.companyName.trim() ? company.companyName : (company.name + " " + company.surname)
    }

    function getMatchingDays(year: number, month: number): Date[] {
        let temp: Date[] = [];

        const availabilities = financialAdvisorState.findByIdFinancialAdvisorResponse ? financialAdvisorState.findByIdFinancialAdvisorResponse.availabilities : [];

        let date = new Date(year, month, 1);

        while (date.getMonth() === month) {
            const dayName = fullDaysMap.get(date.getDay());
            if (availabilities?.some(a => a.day === dayName)) {
                if (date > new Date())
                    temp.push(new Date(date));
            }
            date.setDate(date.getDate() + 1);
        }

        return temp;
    }

    useEffect(() => {
        if(!keycloak.hasRealmRole('admin') && !keycloak.hasRealmRole('operator'))
        dispatch(findAllAppointments({ filters: { ...appointmentsState.filters.companyAll, financialAdvisorId: financialAdvisorState.findByIdFinancialAdvisorResponse?.id }, period: "companyAll" }));
        setMonth(new Date().getMonth())
        setYear(new Date().getFullYear())
        dispatch(setAppointmentCreateRequestCompanyId(undefined))
        if (keycloak.hasRealmRole('financial_advisor') && companyState.findByIdCompanyResponse && window.location.pathname.includes('operation')) {
            dispatch(setAppointmentCreateRequestCompanyId(companyState.findByIdCompanyResponse.id))
        }
    }, [appointmentsState.newAppointmentModal])

    useEffect(() => {
        if (appointmentsState.modalAppointmentType === "save" && appointmentsState.newAppointmentModal) {
            setDate(null)
            setTime(null)
            setErrorTime(false)
        }
    }, [appointmentsState.modalAppointmentType, appointmentsState.newAppointmentModal])

    useEffect(() => {
        if (
            appointmentsState.findByIdAppointmentStatus === "successfully" &&
            appointmentsState.findByIdAppointmentResponse !== undefined &&
            appointmentsState.newAppointmentModal && appointmentsState.modalAppointmentType === "edit"
        ) {
            setDate(new Date(appointmentsState.findByIdAppointmentResponse.startDate))
            setTime(new Date(appointmentsState.findByIdAppointmentResponse.startDate))
            dispatch(setFindByIdAppointmentStatus("idle"))
        }
    }, [appointmentsState.findByIdAppointmentStatus, appointmentsState.newAppointmentModal, appointmentsState.modalAppointmentType])

    useEffect(() => {
        if (((authState.findMeCompanyStatus === "successfully" || companyState.findByIdCompanyStatus === "successfully" || authState.findMeFinancialAdvisorStatus === "successfully") && appointmentsState.newAppointmentModal) && !(window.location.pathname === '/' && keycloak.hasRealmRole('company')))
            dispatch(findByIdFinancialAdvisor(keycloak.hasRealmRole("company") ? authState.findMeCompanyResponse?.financialAdvisor! : keycloak.hasRealmRole("financial_advisor") ? authState.findMeFinancialAdvisorResponse?.id! : companyState.findByIdCompanyResponse?.financialAdvisor!))
    }, [appointmentsState.newAppointmentModal, authState.findMeCompanyStatus, companyState.findByIdCompanyStatus])

    useEffect(() => {
        if (
            financialAdvisorState.findByIdFinancialAdvisorStatus === "successfully" &&
            financialAdvisorState.findByIdFinancialAdvisorResponse?.availabilities !== null &&
            date &&
            appointmentsState.appointments.companyAll.data
        ) {
            const availabilities = financialAdvisorState.findByIdFinancialAdvisorResponse?.availabilities;
            const duration = financialAdvisorState.findByIdFinancialAdvisorResponse?.duration;
            const selectedDay = date.toLocaleString('it-IT', { weekday: 'long' }).toLowerCase();

            const dayAvailability = availabilities?.find(
                (a) => a.day.toLowerCase() === selectedDay
            );

            const bookedStartDates = appointmentsState.appointments.companyAll.data.data.map((appointment) =>
                new Date(appointment.startDate).toISOString()
            );

            if (dayAvailability) {
                const slots: Date[] = [];

                dayAvailability.times.forEach(({ startTime, endTime }) => {
                    const start = new Date(`1970-01-01T${startTime}:00`);
                    const end = new Date(`1970-01-01T${endTime}:00`);
                    const lastValidSlot = new Date(end.getTime() - duration! * 60 * 1000);

                    for (
                        let current = new Date(start);
                        current <= lastValidSlot;
                        current = new Date(current.getTime() + duration! * 60 * 1000)
                    ) {
                        const fullSlot = new Date(
                            date.getFullYear(),
                            date.getMonth(),
                            date.getDate(),
                            current.getHours(),
                            current.getMinutes()
                        );

                        if (!bookedStartDates.includes(fullSlot.toISOString())) {
                            slots.push(fullSlot);
                        }
                    }
                });
                setAvailableSlots(slots);
            } else {
                setAvailableSlots([]);
            }
        }
    }, [date, financialAdvisorState.findByIdFinancialAdvisorStatus, appointmentsState.appointments.company.data]);



    return (
        <ModalComponent
            width="large"
            open={appointmentsState.newAppointmentModal}
            handleClose={() => {
                dispatch(setNewAppointmentModal(false))
            }}
        >
            <div>
                <div
                    style={{
                        boxShadow: '0px 12px 24px 0px rgba(22, 42, 100, 0.12)',
                    }}
                    className={"p-5 bg-white rounded-xl flex flex-col gap-6 w-full"}
                >
                    {
                        appointmentsState.findByIdAppointmentStatus === "loading" || financialAdvisorState.findByIdFinancialAdvisorStatus === "loading" ?
                            <div className="flex justify-center items-center h-[300px]">
                                <SpinnerComponent />
                            </div>
                            :
                            <>
                                <div className="flex items-center justify-between">
                                    <span className="text-heading-xs font-semibold text-neutral-800">
                                        {appointmentsState.modalAppointmentType === "save" ? keycloak.hasRealmRole('company') ? "Richiedi appuntamento" : "Crea appuntamento" : "Modifica appuntamento"}
                                    </span>
                                    {
                                        window.location.pathname.includes('/appointments') &&
                                        <div className="flex justify-end items-center p-0 cursor-pointer">
                                            <CloseIcon
                                                size={"24"}
                                                color={colors.neutral[500]}
                                                onClick={() => dispatch(setNewAppointmentModal(false))}
                                            />
                                        </div>
                                    }
                                </div>
                                <div className="flex flex-col items-start" style={{ gap: '16px', width: '100%' }}>
                                    {(keycloak.hasRealmRole('financial_advisor') && !window.location.pathname.includes('operation')) &&
                                        <SelectComponent
                                            required
                                            key={"new-appointment-company-list"}
                                            label="Azienda"
                                            placeholder={"Seleziona l'azienda"}
                                            options={companyState.findAllCompanyResponse?.data.map((value) => ({ label: value.companyName.trim() ? value.companyName : (value.name + " " + value.surname), value: value.id }))!}
                                            onChange={(value) => dispatch(setAppointmentCreateRequestCompanyId(value))}
                                            value={appointmentsState.modalAppointmentType === 'save' ? appointmentsState.appointmentsCreationRequest.companyId : appointmentsState.findByIdAppointmentResponse?.companyId}
                                            disabled={appointmentsState.modalAppointmentType === 'edit'}
                                        />}
                                    <div className="flex flex-row gap-1 items-center w-full">
                                        <InputComponent
                                            key={"new-event-modal-input-name"}
                                            label="Titolo"
                                            placeholder={"Titolo"}
                                            type="text"
                                            defaultValue={appointmentsState.modalAppointmentType === "save" ? appointmentsState.appointmentsCreationRequest.title : appointmentsState.findByIdAppointmentResponse?.title}
                                            required
                                            onChangeText={(e) => dispatch(setAppointmentCreateRequestTitle(e))}
                                            disabled={appointmentsState.modalAppointmentType === "edit"}
                                        />
                                        <SelectComponent
                                            required
                                            label="Seleziona la tipologia"
                                            placeholder={"Seleziona la tipologia"}
                                            value={appointmentsState.modalAppointmentType === "save" ? appointmentsState.appointmentsCreationRequest.typology : appointmentsState.findByIdAppointmentResponse?.typology}
                                            options={[
                                                { label: "Consulenza fiscale e contabile", value: AppointmentsTypology.consulting },
                                                { label: "Gestione pagamenti F24", value: AppointmentsTypology.payments },
                                                { label: "Scadenze e adempimenti", value: AppointmentsTypology.deadlines },
                                                { label: "Assistenza su bandi e agevolazioni", value: AppointmentsTypology.grants },
                                                { label: "Contratti e buste paga", value: AppointmentsTypology.payroll },
                                                { label: "Budget e pianificazione finanziaria", value: AppointmentsTypology.planning },
                                                { label: "Altro", value: AppointmentsTypology.other }
                                            ]}
                                            onChange={(e) => dispatch(setAppointmentCreateRequestTypology(e))}
                                            noOptionsMessage="Nessun orario disponibile"
                                            disabled={appointmentsState.modalAppointmentType === "edit"}
                                        />
                                    </div>
                                    <div className="flex flex-row gap-1 w-full items-start">
                                        <Calendar
                                            label="Seleziona un giorno"
                                            onMonthChange={setMonth}
                                            onYearChange={setYear}
                                            startDate={date}
                                            setStartDate={(e) => { setDate(e!); setTime(null) }}
                                            type={"date"}
                                            disabled={
                                                (appointmentsState.modalAppointmentType === "edit" && !keycloak.hasRealmRole("financial_advisor")) ||
                                                appointmentsState.findByIdAppointmentResponse?.status === AppointmentsStatus.confirmed ||
                                                financialAdvisorState.findByIdFinancialAdvisorResponse?.availabilities === null
                                            }
                                            markedDates={getMatchingDays(year, month)}
                                        />
                                        <Calendar
                                            label="Scegli l'orario"
                                            startDate={time}
                                            setStartDate={(e) => {
                                                if (e && financialAdvisorState.findByIdFinancialAdvisorResponse?.duration && availableSlots.length) {
                                                    const isValid = availableSlots.some(validDate =>
                                                        validDate.getHours() === e.getHours() &&
                                                        validDate.getMinutes() === e.getMinutes()
                                                    );

                                                    if (isValid) {
                                                        setErrorTime(false)
                                                        setTime(e);
                                                    } else {
                                                        setErrorTime(true)
                                                        setTime(null);
                                                    }
                                                } else {
                                                    setTime(e!);
                                                }
                                            }}
                                            type={"time"}
                                            timeIntervals={financialAdvisorState.findByIdFinancialAdvisorResponse?.duration!}
                                            disabled={
                                                (appointmentsState.modalAppointmentType === "edit" && !keycloak.hasRealmRole("financial_advisor"))
                                                || financialAdvisorState.findByIdFinancialAdvisorResponse?.availabilities === null ||
                                                appointmentsState.findByIdAppointmentResponse?.status === AppointmentsStatus.confirmed
                                            }
                                            includeTimes={availableSlots.filter(slot => slot > new Date())}
                                            error={errorTime}
                                            supportingText={errorTime ? "Orario non disponibile" : ""}
                                        />
                                    </div>
                                    <InputComponent
                                        label="Note"
                                        placeholder="Informazioni sull'appuntamento"
                                        defaultValue={appointmentsState.modalAppointmentType === "save" ? appointmentsState.appointmentsCreationRequest.notes : appointmentsState.findByIdAppointmentResponse?.notes}
                                        onChangeText={(e) => dispatch(setAppointmentCreateRequestNotes(e))}
                                        supportingText={275 - appointmentsState.appointmentsCreationRequest.notes.length + " caratteri rimasti"}
                                        type={"text"}
                                        disabled={appointmentsState.modalAppointmentType === "edit"}
                                    />
                                </div>
                                {
                                    window.location.pathname.includes('/appointments') && appointmentsState.findByIdAppointmentResponse?.status === AppointmentsStatus.pending ?
                                        <div className="flex gap-3 items-center">
                                            <ButtonComponent
                                                label={"Rifiuta"}
                                                onClick={() => {
                                                    dispatch(updateStatusAppointment({ id: appointmentsState.findByIdAppointmentResponse?.id!, request: { status: AppointmentsStatus.refused } }))
                                                    dispatch(setNewAppointmentModal(false))
                                                }}
                                                color={"red"}
                                                variant={"outline"}
                                                size={"sm"}
                                                iconPosition="off"
                                                fullWidth

                                            />
                                            <ButtonComponent
                                                label={"Conferma"}
                                                onClick={() => {
                                                    dispatch(updateStatusAppointment({ id: appointmentsState.findByIdAppointmentResponse?.id!, request: { status: AppointmentsStatus.confirmed } }))
                                                    dispatch(setNewAppointmentModal(false))
                                                }}
                                                color={"green"}
                                                variant={"solid"}
                                                size={"sm"}
                                                iconPosition="off"
                                                fullWidth
                                                disabled={(!keycloak.hasRealmRole("financial_advisor") && appointmentsState.modalAppointmentType === "edit") || (financialAdvisorState.findByIdFinancialAdvisorResponse?.availabilities !== null && financialAdvisorState.findByIdFinancialAdvisorResponse?.availabilities.length === 0)}
                                            />
                                        </div> :
                                        window.location.pathname.includes('/appointments') && appointmentsState.findByIdAppointmentResponse?.status === AppointmentsStatus.confirmed ?
                                            <div className="flex gap-3 items-center">
                                                <ButtonComponent
                                                    label={"Annulla"}
                                                    onClick={() => {
                                                        dispatch(setFindByIdAppointmentResponse(undefined))
                                                        dispatch(setNewAppointmentModal(false))
                                                        dispatch(resetNewAppointmentRequest())
                                                    }}
                                                    color={"gray"}
                                                    variant={"outline"}
                                                    size={"sm"}
                                                    iconPosition="off"
                                                    fullWidth

                                                />
                                                <ButtonComponent
                                                    label={'Cancella'}
                                                    onClick={() => {
                                                        setIsDeleteAppointment(appointmentsState.findByIdAppointmentResponse?.id)
                                                        dispatch(setOpenAppointmentConfirmOrDenyModal(true))
                                                    }}
                                                    color={"blue"}
                                                    variant={"solid"}
                                                    size={"sm"}
                                                    iconPosition="off"
                                                    fullWidth
                                                /></div>
                                            :
                                            <div className="flex gap-3 items-center">
                                                <ButtonComponent
                                                    label={"Annulla"}
                                                    onClick={() => {
                                                        dispatch(setFindByIdAppointmentResponse(undefined))
                                                        dispatch(setNewAppointmentModal(false))
                                                        dispatch(resetNewAppointmentRequest())
                                                    }}
                                                    color={"gray"}
                                                    variant={"outline"}
                                                    size={"sm"}
                                                    iconPosition="off"
                                                    fullWidth

                                                />
                                                <ButtonComponent
                                                    label={appointmentsState.modalAppointmentType === "save" ? "Prenota" : 'Modifica appuntamento'}
                                                    onClick={() => {
                                                        const duration = financialAdvisorState.findByIdFinancialAdvisorResponse?.duration
                                                        const testDate = new Date(date?.getFullYear()!, date?.getMonth()!, date?.getDate(), time?.getHours(), time?.getMinutes(), time?.getSeconds());
                                                        if (appointmentsState.modalAppointmentType === "save") {
                                                            const request: AppointmentsCreateDTO = {
                                                                startDate: isValid(testDate) ? testDate.toISOString() : new Date().toISOString(),
                                                                endDate: isValid(testDate) ? addMinutes(testDate, duration!).toISOString() : addMinutes(new Date(), duration!).toISOString(),
                                                                title: appointmentsState.appointmentsCreationRequest.title,
                                                                notes: appointmentsState.appointmentsCreationRequest.notes,
                                                                financialAdvisorId: keycloak.hasRealmRole('company') ? financialAdvisorState.findByIdFinancialAdvisorResponse?.id! : authState.findMeFinancialAdvisorResponse?.id!,
                                                                companyId: keycloak.hasRealmRole('company') ? authState.findMeCompanyResponse?.id! : appointmentsState.appointmentsCreationRequest.companyId,
                                                                typology: appointmentsState.appointmentsCreationRequest.typology,
                                                                status: keycloak.hasRealmRole('company') ? AppointmentsStatus.pending : AppointmentsStatus.confirmed
                                                            }
                                                            dispatch(appointmentsCreate(request))
                                                            dispatch(resetNewAppointmentRequest())
                                                        } else {
                                                            dispatch(rescheduleAppointment({
                                                                id: appointmentsState.findByIdAppointmentResponse?.id!,
                                                                request: {
                                                                    startDate: isValid(testDate) ? testDate.toISOString() : new Date().toISOString(),
                                                                    endDate: isValid(testDate) ? addMinutes(testDate, duration!).toISOString() : addMinutes(new Date(), duration!).toISOString(),
                                                                }
                                                            }))
                                                        }
                                                        dispatch(setNewAppointmentModal(false))
                                                    }}
                                                    color={"blue"}
                                                    variant={"solid"}
                                                    size={"sm"}
                                                    iconPosition="off"
                                                    fullWidth
                                                    disabled={(!keycloak.hasRealmRole("financial_advisor") && appointmentsState.modalAppointmentType === "edit") || financialAdvisorState.findByIdFinancialAdvisorResponse?.availabilities === null || appointmentsState.findByIdAppointmentResponse?.status === AppointmentsStatus.confirmed
                                                        || (appointmentsState.modalAppointmentType === "save" && appointmentsState.appointmentsCreationRequest.title.trim().length === 0) || date === null || time === null
                                                    }
                                                />
                                            </div>
                                }

                            </>
                    }
                </div>
                <ConfirmModal
                    open={appointmentsState.openAppointmentConfirmOrDenyModal}
                    handleClose={() => dispatch(setOpenAppointmentConfirmOrDenyModal(false))}
                    title={"Elimina appuntamento"}
                    description={"Sei sicuro di voler eliminare questo appuntamento?"}
                    labelDeny={"Annulla"}
                    labelConfirm={"Elimina"}
                    actionConfirm={() => {
                        isDeleteAppointment && dispatch(appointmentsDelete(isDeleteAppointment))
                        dispatch(setOpenAppointmentConfirmOrDenyModal(false))
                        dispatch(setNewAppointmentModal(false))
                    }}
                />
            </div>
        </ModalComponent >
    )
}